import { render, staticRenderFns } from "./jobNumber.vue?vue&type=template&id=19918396&scoped=true"
import script from "./jobNumber.vue?vue&type=script&lang=js"
export * from "./jobNumber.vue?vue&type=script&lang=js"
import style0 from "./jobNumber.vue?vue&type=style&index=0&id=19918396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19918396",
  null
  
)

export default component.exports